<template>
    <div class="sdr-box book-with-us-box" style="border: 1px solid #ec008b;">
        <h4>{{ needhelp[getCurrentLocale] }}</h4>
        <ul>
            <li>
                <i class="soap-icon-trunk-3 circle"></i>
                <h5 class="title"><a href="#" class="skin-color">{{ sideboxhelptext1[getCurrentLocale] }}</a></h5>
                <p>{{ sideboxhelptext2[getCurrentLocale] }}</p>
            </li>
        </ul>
        <br />
        <br />
        <button type="submit" class="btn-medium icon-check uppercase full-width" @click.prevent="onClick_GoBack()">{{ goback[getCurrentLocale] }}</button>
    </div>

</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                needhelp: {
                    en: 'Do you want to see your booking again?',
                    de: 'Wollen Sie Ihre Buchung noch einmal sehen?',
                },
                sideboxhelptext1: {
                    en: 'Back to the start page.',
                    de: 'Zurück zur Startseite.',
                },
                sideboxhelptext2: {
                    en: 'Call up your booking number again.',
                    de: 'Rufen Sie Ihre Buchungsnummer noch einmal auf.',
                },
                goback: {
                    en: 'Back to the booking',
                    de: 'Zurück zur Buchung',
                },

                // currentLocale: 'de',
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagSharedShowFlightSearchResults',
                'actn_FlagServicesShowBookingnoSearchResults',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_GoBack()
            *
            * Desc:
            * Note:
            *
            */
            onClick_GoBack: function() {

                let me = this;


                me.$toc('>>> components/shared/sidebar/BookingNoGoBackBox.vue >>> onClick_GoBack');
                me.actn_FlagSharedShowFlightSearchResults(false);               // Hide 'Section'
                me.actn_FlagServicesShowBookingnoSearchResults(false);          // Hide 'Section'

                me.$router.go(-4);

            }, // eof onClick_GoBack()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/sidebar/BookingNoGoBackBox.vue